<div class="budget-allocation-container" [formGroup]="budgetForm">
    <!-- Total Budget Card -->
    <div class="card budget-card">
        <div class="card-body">
            <div class="row g-4">
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center">
                        <mat-label class="card-label">Total Budget Amount</mat-label>
                        <span class="allocation-info" *ngIf="isEdit">Total Allocation: {{ getNewTotalAllocation() | currencyFormat }}</span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="number" formControlName="totalBudget" (keypress)="numberOnly($event)"
                            placeholder="Enter total budget amount" />
                        <mat-error *ngIf="f['totalBudget'].hasError('pattern') && f['totalBudget'].touched"
                            class="error-messages">
                            Please enter a valid amount (up to 2 decimal places)</mat-error>
                        <mat-error *ngIf="f['totalBudget'].hasError('exceededMaxTotal') && f['totalBudget'].touched"
                            class="error-messages">
                            Total Budget cannot exceed available total budget</mat-error>
                        <mat-error *ngIf="f['totalBudget'].hasError('exceededPlBalance') && f['totalBudget'].touched"
                            class="error-messages">
                            Calculated Pay Later Cap exceeds allowed maximum. Reduce Total Budget or increase Deposit Budget.</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="footer-left">
                <span class="footer-label">Current Balance:</span>
                <span class="footer-value">{{ getTotalBudgetCurrent() | currencyFormat }}</span>
                <!-- <span class="footer-diff" *ngIf="getTotalBudgetDelta() !== 0" [ngClass]="{
                    'diff-positive': getTotalBudgetDelta() > 0,
                    'diff-negative': getTotalBudgetDelta() < 0
                }">
                    {{ formatDelta(getTotalBudgetDelta()) | currency:'USD':'symbol':'1.2-2' }}
                </span> -->
            </div>
            <div class="footer-right">
                <span class="footer-label">Max:</span>
                <span class="footer-value">{{ getMaxTotalBudget() | currencyFormat }}</span>
            </div>
        </div>
    </div>

    <!-- Deposit Budget Card -->
    <div class="card budget-card">
        <div class="card-body">
            <div class="row g-4">
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center">
                        <mat-label class="card-label">Deposit Budget Amount</mat-label>
                        <span class="allocation-info" *ngIf="isEdit">Total Allocation: {{ getNewDepositAllocation() | currencyFormat }}</span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="number" formControlName="depositBudget" (keypress)="numberOnly($event)"
                            placeholder="Enter deposit budget amount" />
                        <mat-error *ngIf="f['depositBudget'].hasError('pattern') && f['depositBudget'].touched"
                            class="error-messages">
                            Please enter a valid amount (up to 2 decimal places)</mat-error>
                        <mat-error
                            *ngIf="f['depositBudget'].hasError('exceededAcBalance') && f['depositBudget'].touched"
                            class="error-messages">
                            Deposit Budget cannot exceed available deposit balance</mat-error>
                        <mat-error
                            *ngIf="f['depositBudget'].hasError('exceededTotalBudget') && f['depositBudget'].touched"
                            class="error-messages">
                            Deposit Budget cannot exceed Total Budget</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="footer-left">
                <span class="footer-label">Current Balance:</span>
                <span class="footer-value">{{ getDepositBudgetCurrent() | currencyFormat }}</span>
                <!-- <span class="footer-diff" *ngIf="getDepositDelta() !== 0" [ngClass]="{
                    'diff-positive': getDepositDelta() > 0,
                    'diff-negative': getDepositDelta() < 0
                }">
                    {{ formatDelta(getDepositDelta()) | currency:'USD':'symbol':'1.2-2' }}
                </span> -->
            </div>
            <div class="footer-right">
                <span class="footer-label">Max:</span>
                <span class="footer-value">{{ getMaxDepositBudget() | currencyFormat }}</span>
            </div>
        </div>
    </div>

    <!-- Pay Later Cap Card -->
    <div class="card budget-card readonly-card">
        <div class="card-body">
            <div class="row g-4">
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center">
                        <mat-label class="card-label">Pay Later Cap</mat-label>
                        <span class="allocation-info" *ngIf="isEdit">Total Allocation: {{ getNewPayLaterAllocation() | currencyFormat }}</span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput type="number" formControlName="payLaterBudget" readonly
                            placeholder="Automatically calculated" />
                        <mat-icon matSuffix class="lock-icon">lock</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="footer-left">
                <span class="footer-label">Current Balance:</span>
                <span class="footer-value">{{ getPayLaterCapCurrent() | currencyFormat }}</span>
                <!-- <span class="footer-diff" *ngIf="getPayLaterDelta() !== 0" [ngClass]="{
                    'diff-positive': getPayLaterDelta() > 0,
                    'diff-negative': getPayLaterDelta() < 0
                }">
                    {{ formatDelta(getPayLaterDelta()) | currency:'USD':'symbol':'1.2-2' }}
                </span> -->
            </div>
            <div class="footer-right">
                <span class="footer-label">Max:</span>
                <span class="footer-value">{{ getMaxPayLaterCap() | currencyFormat }}</span>
            </div>
        </div>
    </div>
</div>